import React, { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthProvider';
import { showLoginModal } from '../../features/login/login.slice';

/**
 * Show empty component with login modal when access private route
 * without authentication.
 */
const EmptyComponent = (): ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showLoginModal(true));
  }, []);

  return <></>;
};

export const PrivateRoute = ({
  children,
  ...rest
}: RouteProps): JSX.Element => {
  const auth = useAuth();

  const renderChild = (): React.ReactNode => {
    if (auth?.isAuthenticated) {
      return children;
    }

    return <EmptyComponent />;
  };

  return <Route {...rest} render={renderChild} />;
};
